import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { IStore } from 'src/app/appModels/IStore';
import { HttpConfigService } from 'src/app/core/httpConfig/httpConfigService';
import { StoreResolver } from '../store/store.resolver';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  store!: IStore|null;
  api = this.apiConfig.getBaseUrl;

  activeOrder = new BehaviorSubject(null);

  constructor(
    private apiConfig: HttpConfigService,
    private _storeResolver: StoreResolver
  ) {
    this.subscribeSelectedStore();
  }


  /**
   * Subscribe Selected Store
   */
  subscribeSelectedStore() {
    this._storeResolver.selectedStore.subscribe(res => {
      this.store = res;
    });
  }


  saveOrder(order:any): Observable<any> {
    return this.apiConfig.post(this.api + 'order/kiosk/save', order, {
      withCredentials: true,
    });
  }

  createOrder(order:any): Observable<any> {
    return this.apiConfig.post(this.api + 'order/cashier/checkout', order, {
      withCredentials: true,
    });
  }

  getOrdersByMobileNumber(mobileNumber: string): Observable<any> {
    return this.apiConfig.get(`${this.api}order/mobileNumber/${mobileNumber}`);
  }

  /**
   * get store Id
   */
  getStoreId() {
    return this.store?.id || null;
  }

  createOrderForGuest(order:any): Observable<any> {
    return this.apiConfig.post(this.api + 'order/guest/checkout', order, {
      withCredentials: true,
    });
  }

  payByCash(checkoutOrderPayload:any): Observable<any> {
    return this.apiConfig.post(
      this.api + 'order/kiosk/checkoutwithcash',
      checkoutOrderPayload,
      { withCredentials: true }
    );
  }

  



    


  markCashOrderAsPaid(id:number, paymentModel:any): Observable<any> {
    return this.apiConfig.post(
      this.api + 'order/paid/cash/' + id,
      paymentModel,
      { withCredentials: true }
    );
  }

  markCardOrderAsPaid(id:number, paymentModel:any): Observable<any> {
    return this.apiConfig.post(
      this.api + 'order/paid/card/' + id,
      paymentModel,
      { withCredentials: true }
    ).pipe(
      tap(response => console.log('markCardOrderAsPaid response:', response)),
      catchError(error => {
        console.error('markCardOrderAsPaid error:', error);
        return throwError(error);
      })
    );
  }



  markCardOrderAsPaidForPlatform(id:number, paymentModel:any): Observable<any> {
    return this.apiConfig.post(
      this.api + 'order/paid/card/' + id + '/platform',
      paymentModel,
      { withCredentials: true }
    ).pipe(
      tap(response => console.log('markCardOrderAsPaidForPlatform response:', response)),
      catchError(error => {
        console.error('markCardOrderAsPaidForPlatform error:', error);
        return throwError(error);
      })
    );
  }


  markOrderAsPaidByManualCard(id:number, paymentModel:any): Observable<any> {
    return this.apiConfig.post(
      this.api + 'order/paid/manual-card/' + id,
      paymentModel,
      { withCredentials: true }
    );
  }


  /**
   * Pay partial Amount
   * @param id
   * @param paymentModel
   * @returns
   */
  payPartialAmountByManualCard(id:number, paymentModel:any): Observable<any> {
    return this.apiConfig.post(
      this.api + 'order/payment/partial-pay/manual-card/' + id,
      paymentModel,
      { withCredentials: true }
    );
  }

  removeOrderById(id:number): Observable<any> {
    return this.apiConfig.delete(this.api + 'order/' + id, {
      withCredentials: true,
    });
  }

  getOrdersByDays(from:any, to:any): Observable<any> {
    if (!this.getStoreId()) {
      return of(null);
    }
    return this.apiConfig.get(
      this.api +
      'order/order-range?from=' +
      from +
      '&to=' +
      to +
      '&storeId=' +
      this.getStoreId(),
      { withCredentials: true }
    );
  }

  getOrderById(id:number): Observable<any> {
    return this.apiConfig.get(this.api + 'order/admin/' + id, {
      withCredentials: true,
    });
  }

   

  deleteOrderPaymentById(orderPaymentId:number): Observable<any> {
    return this.apiConfig.delete(
      this.api + 'order/cashier/payment/' + orderPaymentId
    );
  }

  markOrderAsPaid(orderId: any): Observable<any> {
    return this.apiConfig.patch(this.api + 'order/paid/' + orderId, {
      withCredentials: true,
    });
  }


  updateOrderStatus(orderId: number, status: string): Observable<any> {
    return this.apiConfig.patch(`${this.api}order/update/status/${orderId}/${status}`, {
      withCredentials: true,
    });
  }

   


  
}
